import { MutationStatus, useMutation } from '@tanstack/react-query';
import postTemporaryPasswordApiCall, {
  PostTemporaryPasswordPayload,
} from 'api/calls/postTemporaryPasswordApiCall';

interface UseTemporaryPasswordMutation {
  status: MutationStatus;
  exec: (payload: PostTemporaryPasswordPayload) => void;
}

const useTemporaryPasswordMutation = (): UseTemporaryPasswordMutation => {
  const mutation = useMutation(postTemporaryPasswordApiCall);

  return {
    status: mutation.status,
    exec: mutation.mutate,
  };
};

export default useTemporaryPasswordMutation;
